<template>
  <div id="app">
    <!-- <router-view></router-view>-->
    <app-navbar></app-navbar>
    <app-roomPicker :routeRoomID="$route.params.roomID"></app-roomPicker>
    <app-monster :roomID="$route.params.roomID" :gSheetID="$route.params.gSheetID" v-if="$route.params.gameType=='Monster'||($route.params.gameType!=='DFTQ' && $route.params.gameType!=='FFF' && $route.path !== '/')"></app-monster>
  </div>
</template>

<script>
  import Monster from './components/Monster.vue'
  import RoomPicker from './components/RoomPicker.vue'
  import NavBar from './components/Navbar.vue'

  export default {
    name: 'app',
    components: {
      'app-roomPicker': RoomPicker,
      'app-monster': Monster,
      'app-navbar': NavBar
    },
    data () {
      return {
      }
    },
    mounted () {

    },
    methods: {
    }
  }
</script>

<style lang="scss">

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#app {
  font-family: 'Arvo', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000d1b;
  font-size: 1.1em;
  
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #3c3c3c;
}

.bounce-enter-active {
    animation: bounce-in .5s;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
